module.exports = __webpack_public_path__ + "img/IMG_20220207_142611 - Copy.37dd4147.jpg";